import { ReviewCategory } from '@avantstay/arriere-clients/dist/arriereBackoffice'

import { directLeadSources } from '../../../../constants'
import { RatingBar } from '../../../RatingBar'
import { MMedium } from '../../../Typography'
import { DetailedReviews } from './components/DetailedReviews'
import { ReplyReviewAction } from './components/ReplyReviewAction'
import { ReviewComments } from './components/ReviewComments'
import * as S from './Review.styles'
import { ReviewProps } from './Review.types'
import { getOverallRating, hasTagsOrComments } from './Review.utils'

export const Review = ({
  hideComments,
  isLastReview,
  isLastReviewOnPage,
  review,
  canReplyReview,
  onReplyReview,
  afterRatings,
}: ReviewProps) => {
  const { categoryReviews, id, privateFeedback, response, source } = review

  const isSourceAvantStay = directLeadSources.includes(source)
  const overallRating = getOverallRating({ categoryReviews })
  const detailedReviews = categoryReviews?.filter(
    reviewDetail =>
      reviewDetail.category !== ReviewCategory.overall &&
      reviewDetail.category !== ReviewCategory.nps,
  )

  return (
    <S.ReviewCardContainer isLastReview={isLastReview} isLastReviewOnPage={isLastReviewOnPage}>
      <S.ReviewBreakdownContainer shouldDisplayAsColumn={hasTagsOrComments(detailedReviews)}>
        <div>
          <MMedium>{isSourceAvantStay ? 'NPS' : 'Overall'}</MMedium>
          {overallRating ? (
            <RatingBar
              isNPS={overallRating.category === ReviewCategory.nps}
              isOverall
              rating={overallRating.rating}
            />
          ) : null}
        </div>

        <DetailedReviews categoryReviews={detailedReviews} reviewId={id} />
      </S.ReviewBreakdownContainer>

      {afterRatings}

      <ReviewComments
        reviewComments={[
          {
            label: isSourceAvantStay ? 'Private NPS Review' : 'Public Review',
            content: overallRating?.comment,
          },
          { label: 'Private Review', content: privateFeedback },
          {
            label: 'Response',
            content: response,
            action: isSourceAvantStay ? null : (
              <ReplyReviewAction
                review={review}
                canReplyReview={canReplyReview}
                onReplyReview={onReplyReview}
              />
            ),
          },
        ]}
        hideComments={hideComments}
      />
    </S.ReviewCardContainer>
  )
}

Review.Comments = ReviewComments
